import { CHANNEL_ROLE_COPY } from '../../data/channelRoleCopy';
import type { ChannelRoleRule } from '../../data/schemas';
import type { ChannelRoleResult, EvaluationContext } from '../../types/result';
import { evaluateConditionGroup } from '../tensions/evaluateRuleCondition';

/**
 * Bestimmt die empfohlene Instagram-Rolle (Abschnitt 19). Regeln werden nach Priorität absteigend
 * ausgewertet; die erste zutreffende Regel gewinnt. Eine Regel ohne Bedingungen ist die Standardregel.
 */
export function determineChannelRole(
  context: EvaluationContext,
  rules: readonly ChannelRoleRule[],
): ChannelRoleResult {
  const sorted = [...rules].sort((a, b) => b.priority - a.priority);
  const match = sorted.find((rule) => evaluateConditionGroup(rule.conditions, 'all', context));

  if (!match) {
    throw new Error('Keine Kanalrollen-Regel hat gegriffen, auch nicht die Standardregel.');
  }

  const copy = CHANNEL_ROLE_COPY[match.result.role];

  return {
    role: match.result.role,
    label: match.result.label,
    summary: copy.summary,
    explanation: copy.explanation,
    suitableUses: copy.suitableUses,
    unsuitableUses: copy.unsuitableUses,
    confidence: match.result.confidence,
  };
}
